<template>
    <div>
        <label class="block text-sm font-medium leading-5 text-gray-800 relative"
            :class="{'required': required, 'font-bold' : bold}"
            :for="name"
            v-if="label">
            {{ label }}
            <font-awesome-icon class="text-xs text-black ml-1 cursor-pointer"
                :icon="['fas', 'question-circle']"
                style="margin-top: 2px;"
                v-if="tooltip" v-tooltip="tooltip" />
        </label>
        <div class="mt-1">
            <ValidationProvider :name="label" mode="lazy" :rules="rules" v-slot="{ errors }" tag="div">
                <div class="mt-1" :class="{'h-full': full}">
                    <textarea v-model="model"
                        :id="name"
                        @input="onInput"
                        @blur="onBlur"
                        :name="name"
                        :ref="name"
                        :placeholder="placeholder ? placeholder : ''"
                        :readonly="readonly"
                        :disabled="disabled"
                        autocomplete="Off"
                        data-lpignore="true"
                        :rows="rows ? rows : 4"
                        class="form-input block w-full transition duration-150 ease-in-out sm:text-sm leading-normal text-gray-700 py-3"
                        :class="{ 'border-red-700' : errors[0], 'h-full': full, 'opacity-50 cursor-not-allowed' : disabled, 'readonly bg-gray-200 cursor-default border-gray-400' : readonly }"
                        @keydown="inputHandler"
                        :style="inputStyle"
                    />
                </div>
                <span class="text-xs text-red-700 absolute">{{ errors[0] }}</span>
            </ValidationProvider>
        </div>
    </div>
</template>

<script>
    export default {
        name: "InputText",
        props: ['label', 'value', 'name', 'placeholder', 'readonly', 'rules', 'mask', 'required', 'disabled', 'type', 'tooltip', 'dollar', 'rows', 'full', 'inputStyle', 'bold'],
        data: function(){
            return {
                model: null
            }
        },
        mounted() {
            if (this.value){
                this.model = this.value;
            }
        },
        methods: {
            inputHandler(e) {
                if (e.keyCode === 13 && e.shiftKey) {
                    e.preventDefault();
                    this.$emit('save');
                }
            },
            onInput (event) {
                if (event.target){
                    this.$emit('input', event.target.value);
                } else {
                    // Used for Masked Input
                    this.$emit('input', event);
                }
            },
            onBlur (event) {
                if (event.target){
                    this.$emit('blur', event.target.value);
                } else {
                    // Used for Masked Input
                    this.$emit('blur', event);
                }
            }
        },
        watch: {
            value: function(newVal){
                this.model = newVal;
                this.$emit('input', newVal);
            },
        }
    }
</script>

<style scoped>

</style>
